import _ from 'lodash';
import moment from 'moment';
import { personName, personEmails } from '../utils/people_helpers';

const formatDate = (day, time) => {
  if (day) {
    if (time) {
      return new Date(`${day} ${time}`);
    }
    return new Date(day);
  }
  return null;
};

const compareItemsForSortFunctions = (itemA, itemB) => {
  if (itemA && itemB) {
    return itemA.localeCompare(itemB);
  } else if (!itemA && itemB) {
    return -1;
  } else if (itemA && !itemB) {
    return 1;
  }
  return 0;
};

const sortAssignmentsByName = (assignmentCollection1, assignmentCollection2) => {
  const sortedCollection1 = _.sortBy(_.map(assignmentCollection1, 'company_person'), [personName]);
  const sortedCollection2 = _.sortBy(_.map(assignmentCollection2, 'company_person'), [personName]);
  const newA = _.lowerCase(personName(_.head(sortedCollection1)));
  const newB = _.lowerCase(personName(_.head(sortedCollection2)));

  return compareItemsForSortFunctions(newA, newB);
};

const sortBy = (object1, object2, value) => {
  let newA = _.get(object1, value);
  let newB = _.get(object2, value);
  newA = typeof newA === 'string' ? newA.toLowerCase() : newA;
  newB = typeof newB === 'string' ? newB.toLowerCase() : newB;

  return compareItemsForSortFunctions(newA, newB);
};

const sortByEmail = (object1, object2) => {
  let newA = personEmails(object1);
  let newB = personEmails(object2);
  newA = typeof newA === 'string' ? newA.toLowerCase() : newA;
  newB = typeof newB === 'string' ? newB.toLowerCase() : newB;

  return compareItemsForSortFunctions(newA, newB);
};

const sortByPersonName = (object1, object2) => {
  let newA = personName(object1);
  let newB = personName(object2);
  newA = typeof newA === 'string' ? newA.toLowerCase() : newA;
  newB = typeof newB === 'string' ? newB.toLowerCase() : newB;

  return compareItemsForSortFunctions(newA, newB);
};

const sortByNumber = (number1, number2) => {
  if (number1 > number2) {
    return 1;
  } else if (number1 < number2) {
    return -1;
  }
  return 0;
};

const sortNumberWithZero = (number1, number2, desc) => {
  const isInfinity = desc ? -Infinity : +Infinity;
  const number1Value = number1 === 0 ? isInfinity : number1;
  const number2Value = number2 === 0 ? isInfinity : number2;

  return sortByNumber(number1Value, number2Value);
};

const sortDateWithZero = (date1, date2, desc) => {
  const isInfinity = desc ? +Infinity : -Infinity;
  const date1Value = date1 === null ? isInfinity : moment(date1).unix();
  const date2Value = date2 === null ? isInfinity : moment(date2).unix();
  return sortByNumber(date1Value, date2Value);
};

const sortDateAndTime = (date1, date2, desc) =>
  sortDateWithZero(
    date2 ? formatDate(date2.date, date2.time) : null,
    date1 ? formatDate(date1.date, date1.time) : null,
    desc,
  );

const sortPriority = (type1, type2) => {
  const type = ['urgent', 'high', 'normal', 'low', 'watch'];
  const indexOfType1 = _.indexOf(type, type1);
  const indexOfType2 = _.indexOf(type, type2);
  return sortByNumber(indexOfType1, indexOfType2);
};

const sortStatus = (task1, task2) => {
  const taskSatatuses = [
    'created',
    'assigned',
    'in_progress',
    'finished',
    'closed',
    'approved',
    'deleted',
  ];
  const stage1 = _.get(task1, 'type_task_status.stage', '');
  const stage2 = _.get(task2, 'type_task_status.stage', '');
  const indexOfType1 = _.indexOf(taskSatatuses, stage1);
  const indexOfType2 = _.indexOf(taskSatatuses, stage2);
  return sortByNumber(indexOfType1, indexOfType2);
};

export default {
  sortAssignmentsByName,
  sortBy,
  sortByEmail,
  sortByNumber,
  sortByPersonName,
  sortDateAndTime,
  sortDateWithZero,
  sortNumberWithZero,
  sortPriority,
  sortStatus,
};
